module.exports = __webpack_public_path__ + "img/img-1.00b26240.jpeg";